module.exports = __webpack_public_path__ + "/img/931a7c8d4e930e1afa3cad443db0d5b6.png";